import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import GraduationProgressBar from './GraduationProgressBar';
import { GraduationProgress } from './studentGraduation';

interface GraduationProgressCardProps {
  progress: GraduationProgress;
  onGraduate: () => void;
}

export default function GraduationProgressCard({ progress, onGraduate }: GraduationProgressCardProps) {
  return (
    <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, borderRadius: 4, border: '1px solid rgba(18,18,18,0.08)' }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 1.5, md: 3 }} alignItems={{ md: 'center' }}>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ mb: 1.25 }}>
            <Typography variant="overline" sx={{ color: 'text.secondary', lineHeight: 1, fontSize: 10, display: 'block' }}>
              Progreso de graduación
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}>
              {progress.isReviewReady ? 'Revisión manual para cinturón' : `Siguiente: ${progress.objective}`}
            </Typography>
          </Box>

          <GraduationProgressBar progress={progress} showEstimate />
        </Box>

        <Button
          variant="contained"
          startIcon={<MilitaryTechIcon />}
          onClick={onGraduate}
          sx={{
            bgcolor: '#111111',
            borderRadius: 2,
            textTransform: 'none',
            px: 3,
            py: 1,
            whiteSpace: 'nowrap',
            alignSelf: { xs: 'stretch', md: 'auto' },
            '&:hover': { bgcolor: '#2a2a2a' },
          }}
        >
          Graduar alumno
        </Button>
      </Stack>
    </Paper>
  );
}
